export const COMPANY_SIZE_OVER_100_NAME = '101';

export const formatCompanySizeLabel = (name?: string | null) => {
  if (!name) {
    return '';
  }

  return name === COMPANY_SIZE_OVER_100_NAME ? '100+' : name;
};

export const getCompanySeatLimit = (name?: string | null) => {
  const limit = Number.parseInt(name ?? '', 10);

  return Number.isInteger(limit) && limit > 0 ? limit : null;
};
